import { DataService } from './../../_services/data.service';
import { Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { InvoiceService } from '../../invoices/invoice.service';
import { PayService } from '../../invoices/pay.service';
import { LayoutService } from '../../_layouts/layoutService';
import { FilterService } from '../../_services/filter.service';
import { RouteNavigationService } from '../../_services/routeNavigationService';
import { ListDisplayService } from './list-display.service';
import { SearchbarService } from '../../_services/searchbar.service';
import { CurrencyDisplayService } from '../../_services/currency-display.service';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceManualKnockOffService } from '../../invoices/invoice-knock-off/invoice.manual.knockoff.service';
import { DialogService } from '../../_services';
import { AppDialogsService } from '../../_services/appDialogsService';

@Component({
  selector: 'list-display',
  templateUrl: './list-display.component.html',
})
export class ListDisplayComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() options: any = {};
  @Output() onAction = new EventEmitter();
  @Output() onDataLoaded = new EventEmitter();
  @Input() breadCrumbs
  tableConfig: any = this.listDisplayService.getDefaultTableConfig();
  @ContentChild(TemplateRef) cardDisplayTemplate: TemplateRef<any>;
  isMobileMode = false;
  isCardMode = false;
  breadCrumbItems = [];
  filtersVisible = false;
  showSearchBar = true;
  @Output() tableConfigEmitter = new EventEmitter();

  enterPinOptions: any = {
    header: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
    subttitle: this.translate.instant('MESSAGES.ENTER_TRANSACTION_PIN'),
    payexPin: ''
  };

  invoiceNoSearchText = '';
  invoiceNoToSearch = '';
  selectableInvoicesCount = 0;
  showClearSelection = false;
  listData: any = {
    invoices: [],
    filters: {}
  };
  showSearchInput = false;

  searchplaceholder = 'LABELS.SEARCH_BY_DOC_NO_NEW';
  searchId = 'INVOICE_SEARCH_INPUT';
  multiPayFlagDisplay = false;
  
  // Expandable rows tracking
  expandedRows: Set<string> = new Set();

  @ViewChild('searchInput', { static: false }) searchInputRef: ElementRef;
  private shouldFocusSearch = false;

  constructor(
    private listDisplayService: ListDisplayService,
    private layoutService: LayoutService,
    private filtersService: FilterService,
    public invoiceService: InvoiceService,
    private dataService: DataService,
    private payService: PayService,
    private routeNavigationService: RouteNavigationService,
    private currDisplayService: CurrencyDisplayService,
    public searchbarService : SearchbarService,
    private translateService: TranslateService,
    private translate: TranslateService,
    private invoiceKnockOffService: InvoiceManualKnockOffService,
    private dialogService: DialogService,
    private appDialogsService: AppDialogsService,
    private routeNavService: RouteNavigationService,
    private cdr: ChangeDetectorRef
  ) {
    if (!this.breadCrumbs) {
      this.breadCrumbs = this.breadCrumbItems;
    }
  }

  ngOnInit() {
    var extrenalapplied = this.filtersService.getNavFilters();
    if(extrenalapplied){
      this.filtersVisible=true;
    }
    this.searchBarPlaceholder();

    this.tableConfig = this.listDisplayService.getTableConfig(this.options.listType);

    // console.log('table config.....');

    // console.log(this.tableConfig);

    this.tableConfig.onDataLoaded = () => {
      this.onDataLoaded.emit(this.tableConfig.listData);
      this.sendTableConfigData();
    }
    this.listDisplayService.getListData(this.tableConfig, Object.assign({}, this.options));
    // if (!this.options.hideBreadCrumb) {
    //   this.breadCrumbItems = [{active: false, path: '', label: 'Home'}, {active: true, path: '', label: this.options.title}]
    // }
    this.setMobileDisplayMode();
  }

  ngAfterViewChecked() {
    if (this.shouldFocusSearch && this.searchInputRef?.nativeElement) {
      setTimeout(() => {
        this.searchInputRef?.nativeElement?.focus();
        this.shouldFocusSearch = false;
      }, 0);
    }
  }

  toggleSearchInput() {
    const wasHidden = !this.showSearchInput;
    this.showSearchInput = !this.showSearchInput;
    
    if (this.showSearchInput && wasHidden) {
      // Set flag to focus after view updates
      this.shouldFocusSearch = true;
      this.cdr.detectChanges();
    } else if (!this.showSearchInput) {
      this.resetFilters();
    }
  }

  sendTableConfigData(){
    // console.log(this.tableConfig);
    
    this.tableConfigEmitter.emit(this.tableConfig);
  }

  isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === dateString;
  }

  dayWithSuffix(day) {
    const suffix = ['st', 'nd', 'rd'][day % 10 - 1] || 'th'
    day = parseInt(day)
    return day + suffix
  }

  extractCashDiscountData(cdString) {
    const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOMBER', 'NOVEMBER', 'DECEMBER,'];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const data = cdString.split(' ');
    const dataObject: any = {};
    
    // Parse the string: "Pay by Wed Feb 04 2026 00:00:00 GMT+0530 and get discount of 2.5% INR 22.675"
    const currencyCodes = ['INR', 'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'CAD'];
    
    data.forEach((element, index) => {
      // Find percentage (contains %)
      if (element.includes('%')) {
        dataObject['percentage'] = element;
      }
      
      // Find currency code and amount together
      if (currencyCodes.includes(element.toUpperCase()) && index + 1 < data.length) {
        dataObject['currencyCode'] = element.toUpperCase();
        const numValue = parseFloat(data[index + 1]);
        if (!isNaN(numValue)) {
          dataObject['amount'] = data[index + 1];
        }
      }
      
      // Find date - look for month name followed by day and year
      const monthIndex = monthNames.findIndex(m => element.startsWith(m));
      if (monthIndex !== -1 && index + 2 < data.length) {
        const day = data[index + 1];
        const year = data[index + 2];
        if (!isNaN(parseInt(day)) && !isNaN(parseInt(year))) {
          const month = months[monthIndex];
          dataObject['date'] = this.translate.instant(`LABELS.${month}`) + ' ' + `${this.dayWithSuffix(day)},` + ' ' + year;
        }
      }
    });
    
    // Fallback: if date not found, try to parse the full date string
    if (!dataObject['date']) {
      const dateMatch = cdString.match(/(\w{3})\s+(\w{3})\s+(\d{1,2})\s+(\d{4})/);
      if (dateMatch) {
        const monthIndex = monthNames.findIndex(m => m === dateMatch[2]);
        if (monthIndex !== -1) {
          const month = months[monthIndex];
          dataObject['date'] = this.translate.instant(`LABELS.${month}`) + ' ' + `${this.dayWithSuffix(dateMatch[3])},` + ' ' + dateMatch[4];
        }
      }
    }
    
    // Fallback: if amount/currency not found at expected positions, search more broadly
    if (!dataObject['amount'] || !dataObject['currencyCode']) {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const currencyCodes = ['INR', 'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'CAD'];
        if (currencyCodes.includes(element.toUpperCase()) && i + 1 < data.length) {
          dataObject['currencyCode'] = element.toUpperCase();
          const numValue = parseFloat(data[i + 1]);
          if (!isNaN(numValue)) {
            dataObject['amount'] = data[i + 1];
            break;
          }
        }
      }
    }
    
    const amtWithCurrency = dataObject['amount'] && dataObject['currencyCode'] 
      ? this.currDisplayService.getFormattedCurrencyStr({amt: dataObject['amount'], curr: dataObject['currencyCode']})
      : '';
    
    return this.translate.instant('LABELS.ELIGIBLE_FOR_PER_CASH_DISCOUNT_AMT_BY_DATE', {
      per: dataObject['percentage'] || '',
      amt: amtWithCurrency,
      date: dataObject['date'] || ''
    });
  }

  getCashDiscountCompact(data: any) {
    if (!data?.messages?.length) return null;
    const cdString = data.messages[0].msg;
    const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOMBER', 'NOVEMBER', 'DECEMBER,'];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dataArray = cdString.split(' ');
    const dataObject: any = {};
    
    // Parse the string: "Pay by Wed Feb 04 2026 00:00:00 GMT+0530 and get discount of 2.5% INR 22.675"
    const currencyCodes = ['INR', 'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'CAD'];
    
    dataArray.forEach((element, index) => {
      // Find percentage (contains %)
      if (element.includes('%')) {
        dataObject['percentage'] = element;
      }
      
      // Find currency code and amount together
      if (currencyCodes.includes(element.toUpperCase()) && index + 1 < dataArray.length) {
        dataObject['currencyCode'] = element.toUpperCase();
        const numValue = parseFloat(dataArray[index + 1]);
        if (!isNaN(numValue)) {
          dataObject['amount'] = dataArray[index + 1];
        }
      }
      
      // Find date - look for month name followed by day and year
      const monthIndex = monthNames.findIndex(m => element.startsWith(m));
      if (monthIndex !== -1 && index + 2 < dataArray.length) {
        const day = dataArray[index + 1];
        const year = dataArray[index + 2];
        if (!isNaN(parseInt(day)) && !isNaN(parseInt(year))) {
          const month = months[monthIndex];
          dataObject['date'] = this.translate.instant(`LABELS.${month}`) + ' ' + `${this.dayWithSuffix(day)},` + ' ' + year;
        }
      }
    });
    
    // Fallback: if date not found, try to parse the full date string
    if (!dataObject['date']) {
      const dateMatch = cdString.match(/(\w{3})\s+(\w{3})\s+(\d{1,2})\s+(\d{4})/);
      if (dateMatch) {
        const monthIndex = monthNames.findIndex(m => m === dateMatch[2]);
        if (monthIndex !== -1) {
          const month = months[monthIndex];
          dataObject['date'] = this.translate.instant(`LABELS.${month}`) + ' ' + `${this.dayWithSuffix(dateMatch[3])},` + ' ' + dateMatch[4];
        }
      }
    }
    
    // Fallback: if amount/currency not found at expected positions, search more broadly
    if (!dataObject['amount'] || !dataObject['currencyCode']) {
      for (let i = 0; i < dataArray.length; i++) {
        const element = dataArray[i];
        const currencyCodes = ['INR', 'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'CAD'];
        if (currencyCodes.includes(element.toUpperCase()) && i + 1 < dataArray.length) {
          dataObject['currencyCode'] = element.toUpperCase();
          const numValue = parseFloat(dataArray[i + 1]);
          if (!isNaN(numValue)) {
            dataObject['amount'] = dataArray[i + 1];
            break;
          }
        }
      }
    }
    
    const amtWithCurrency = dataObject['amount'] && dataObject['currencyCode'] 
      ? this.currDisplayService.getFormattedCurrencyStr({amt: dataObject['amount'], curr: dataObject['currencyCode']})
      : '';
    
    return {
      percentage: dataObject['percentage'] || '',
      amount: amtWithCurrency,
      date: dataObject['date'] || '',
      fullText: cdString // Return original string as fallback
    };
  }

  searchBarPlaceholder(){
    if(this.options.listType==='transactions'){
      this.multiPayFlagDisplay = true;
      this.searchplaceholder='LABELS.SEARCH_BY_TRANSACTION_NO_NEW';
      this.searchId = 'TRANSACTION_SEARCH_INPUT';
    }
  }

  ngOnDestroy() {
  }

  loadNextPage() {
  }

  sortByField(col) {
    this.listDisplayService.sortByField(this.tableConfig, col);
  }

  onPageChange(event) {
    this.tableConfig.pageSize = parseInt(this.tableConfig.pageSize);
    this.listDisplayService.onPageChange(this.tableConfig, event);
  }

  doAction(data, action) {
    if(action.action === 'multiPay'){
      this.goToMultiPay();
    }else{
      this.onAction.emit({ data, action });
    }
  }

  setMobileDisplayMode() {
    this.isMobileMode = this.layoutService.isMobileMode();
  }

  toggleCardMode() {
    this.isCardMode = !this.isCardMode;
  }

  filtersApplied(data) {
    // console.log("data : ", data);
    this.tableConfig.listData.filters.isAllAppliedRules = data.length > 0;
    this.listDisplayService.filtersApplied(this.tableConfig);
  }

  refreshData() {
    this.listDisplayService.getListData(this.tableConfig, { hardRefresh: true });
  }

  dataSelectionToggled(data) {
    if(!this.tableConfig.hideTopFilter){
      this.onAction.emit({ data, action: { 'action': 'select' } });
    }else{
      this.invoiceKnockOffService.processInvoiceSelectionForPayment(this.tableConfig.listData);
    }
  }

  generateQRCode(data) {
    this.onAction.emit({ data, action: { 'action': 'qrCode' } });
  }

  resetFilters() {
    this.filtersService.resetFilters(this.tableConfig.dataList, this.tableConfig.listData.filters);
    this.filtersApplied({});
    this.invoiceNoSearchText = '';
  }

  selectAllDataSelectionToggled(event, data) {
    if(!this.tableConfig.hideTopFilter){
      this.onAction.emit(
      {
        data: {
          selectAll: event.target.checked,
          documents: data.currentPageDocuments
        },
        action: { 'action': 'selectAllToggled' }
      });
    }else{
      this.tableConfig.listData.invoices.forEach(inv => {
        if(!inv.selectionDisabled && event.target.checked){
          inv.selected = true;
        } else if(!inv.selectionDisabled && !event.target.checked){
          inv.selected = false;
        } 
      });
      this.invoiceKnockOffService.processInvoiceSelectionForPayment(this.tableConfig.listData);
    }
  }

  goToMultiPay() {
    this.payService.setInvoicesForPay(this.invoiceService.getSelectedInvoices()).then(data => {
      this.routeNavigationService.navigateForward('/invoices/pay');
    });
  }

  clearAllSelecteddata() {
    this.tableConfig.selectAllToggle = false;
    if(this.tableConfig.hideTopFilter){
      this.tableConfig.listData.invoices.forEach(inv => {
        if(!inv.selectionDisabled){
          inv.selected = false;
        }
      });
      this.invoiceKnockOffService.processInvoiceSelectionForPayment(this.tableConfig.listData);
    }
    this.onAction.emit(
      {
        data: {},
        action: { 'action': 'clearAllSelectionData' }
      });
  }

  onInvoiceSearched() {
    if (this.options.listType === 'transactions') {
      const invoiceNumToSearch = this.invoiceNoSearchText//this.dataService.replaceAll(((this.invoiceNoSearchText) || ''), ' ', '');
      //console.log(invoiceNumToSearch);

      if (invoiceNumToSearch) {
        this.tableConfig.currentPageDocuments = this.tableConfig.dataList.filter((item) => item.tranId.toLowerCase().includes(invoiceNumToSearch.toLowerCase().trim()));
      } else {
        this.resetFilters();
      }
    } else {
      const invoiceNumToSearch = this.dataService.replaceAll(((this.invoiceNoSearchText) || ''), ' ', '');
      //console.log(invoiceNumToSearch);

      if (invoiceNumToSearch) {
        this.tableConfig.currentPageDocuments = this.tableConfig.dataList.filter((item) => item.docNo.toLowerCase().includes(invoiceNumToSearch.toLowerCase().trim()));
      } else {
        this.resetFilters();
      }
    }
  }

  goToInvoices() {
    this.routeNavService.navigateRoot('invoices');
  }

  toggleRowExpansion(data: any) {
    const rowId = data.docNo || data.tranNo || data.id;
    if (this.expandedRows.has(rowId)) {
      this.expandedRows.delete(rowId);
    } else {
      this.expandedRows.add(rowId);
    }
  }

  isRowExpanded(data: any): boolean {
    const rowId = data.docNo || data.tranNo || data.id;
    return this.expandedRows.has(rowId);
  }

  processKnockOff() {
    const doProcess = () => {
      this.appDialogsService.openPinEnterDialog(this.enterPinOptions, (result) => {
        if (result) {
          const payexPin = this.enterPinOptions.payexPin;
          this.setAppBusy();
          this.invoiceKnockOffService.doManualKnockOff(this.tableConfig.listData, payexPin).subscribe(data => {
            this.setAppIdle();
            this.dialogService.showInfoAlert(data.msg);
            this.goToInvoices();
          }, () => {
            this.setAppIdle();
            this.enterPinOptions.payexPin = "";
          });
        }
      });
    }
    const confirmMsg = this.invoiceKnockOffService.getManualKnockoffSelectionMessage(this.tableConfig.listData);
    if (confirmMsg) {
      this.dialogService.showConfirmDialog({
        header: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
        message: confirmMsg,
        ok: this.translate.instant('LABELS.OK'),
        cancel: this.translate.instant('LABELS.CANCEL')
      }).then((res) => {
        if (res) {
         doProcess();
        }
      });
    } else {
      doProcess();
    }

  }


  setAppBusy() {
    this.dialogService.showWaitMessage();
  }

  setAppIdle() {
    this.dialogService.hideWaitMessage();
  }

}
